/**
 * @author Kelnik
 *
 * YandexMapPopup - Карта в попапе
 */

import YandexMap from 'components/yandex-map';

class YandexMapMini {
    constructor(options) {
        this.container = options.container;

        this.ymaps = window.ymaps;
    }

    init() {
        if (!this.container || !this.ymaps) {
            return;
        }

        this._initMap();
    }

    _initMap() {
        this.ymaps.ready(() => {
            this.map = new YandexMap(this.ymaps);

            this.map.init({
                wrapper                : this.container,
                cluster                : false,
                fullScreenControl      : false,
                customFullScreenControl: false,
                customZoomControl      : false,
                disableZoom            : true,
                zoomControl            : false
            });
        });
    }
}

export default YandexMapMini;
